import { render, staticRenderFns } from "./BriefDaily.vue?vue&type=template&id=12947ee8&scoped=true"
import script from "./BriefDaily.vue?vue&type=script&lang=js"
export * from "./BriefDaily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12947ee8",
  null
  
)

export default component.exports